import { SvgIconComponent } from '@mui/icons-material';
import LanguageIcon from '@mui/icons-material/Language';
import FolderIcon from '@mui/icons-material/Folder';
import LabelIcon from '@mui/icons-material/Label';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { CategoryTypeName } from './growCategoryRestriction.types';

export const INDENT_PX = 20;

export const LEVEL_INDENT: Record<CategoryTypeName, number> = {
    zone: 0,
    topCategory: INDENT_PX,
    category: INDENT_PX * 2,
    productType: INDENT_PX * 3,
};

export const LEVEL_TAG_SX: Record<CategoryTypeName, object> = {
    zone: { bgcolor: '#1565c0', color: '#fff', fontWeight: 700, fontSize: 10, height: 18, letterSpacing: 0.3 },
    topCategory: { bgcolor: '#dbeafe', color: '#1d4ed8', fontWeight: 600, fontSize: 10, height: 18 },
    category: { bgcolor: '#dcfce7', color: '#166534', fontWeight: 600, fontSize: 10, height: 18 },
    productType: { bgcolor: '#f3e8ff', color: '#6b21a8', fontWeight: 600, fontSize: 10, height: 18 },
};

export const ICON_COLOR: Record<CategoryTypeName, string> = {
    zone: '#1976d2',
    topCategory: '#3b82f6',
    category: '#22c55e',
    productType: '#a855f7',
};

export const LEVEL_ICON: Record<CategoryTypeName, SvgIconComponent> = {
    zone: LanguageIcon,
    topCategory: FolderIcon,
    category: LabelIcon,
    productType: LocalOfferIcon,
};

export const ICON_SIZE: Record<CategoryTypeName, number> = {
    zone: 16,
    topCategory: 15,
    category: 14,
    productType: 13,
};

export const ROW_BG: Record<CategoryTypeName, string> = {
    zone: 'rgba(25,118,210,0.04)',
    topCategory: 'transparent',
    category: 'transparent',
    productType: 'transparent',
};

export const LevelIcon = ({ typeName }: { typeName: CategoryTypeName }) => {
    const Icon = LEVEL_ICON[typeName];
    const color = ICON_COLOR[typeName];
    const size = ICON_SIZE[typeName];
    return (
        <Icon
            sx={{
                fontSize: size,
                color,
                filter: `drop-shadow(0 1px 2px ${color}55)`,
                flexShrink: 0,
            }}
        />
    );
};
